import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const userList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.post('/user/list', {
        body: {
          pageSize: state.pageSize,
          pageNumber: state.pageNumber,
          ...query,
        },
      }),
    { pageSize, pageNumber },
  );
};

export const userUpdateStatus = (params) => {
  return _baseClient.get('/user/update-status', params);
};

export const userAdd = (params) => {
  return _baseClient.post('/user/save', { body: params }).then((response) => {
    return response;
  });
};

export const userUpdateProfilePhoto = (params) => {
  return _baseClient.post('/profile/update-photo', { body: params }).then((response) => {
    return response;
  });
};

export const userUpdateOutlookSetting = (params) => {
  return _baseClient.post('/profile/update-outlook-setting', { body: params }).then((response) => {
    return response;
  });
};

export const unitUsers = (params) => {
  return _baseClient.post('/user/get-unit-users', { body: params });
};

export const userDetail = (params) => {
  return _baseClient.get('/user/get', params);
};

export const userListExport = (params) => {
  return _baseClient.post('/user/export', { body: params });
};

export const getUserUnitTaskCount = (params) => {
  return _baseClient.get('/user/get-unit-task-count', params);
};

export const fileUploadUrl = (params) => {
  return _baseClient.get('/file-upload-url', params);
};

export const fileUpload = (formData) => {
  return _baseClient.postFormData('/file-upload', { body: formData });
};

export const fileDownloadUrl = ({ fileId }) => {
  return _baseClient.get(`/file-download/${fileId}`);
};

export const downloadUserSampleCsv = (params) => {
  return _baseClient.get('/user/download-sample-csv', params);
};
